//--------------------------------------------------------------------
//
//  functions.js
//
//--------------------------------------------------------------------

var retryCount = 0;

// オブジェクトの個数カウント
function count( obj ) {
	var cnt = 0;
	for ( var key in obj ) { cnt++; }
	return cnt;
}

// No Image
function defaultImg( id, category ) { 
	switch( category ) {
		case "page"		: $( id )[0].src = "https://www.nissen.co.jp/d_catalog/app/d_images/no_image.png"; break;
		case "thumb"	: $( id )[0].src = "https://www.nissen.co.jp/d_catalog/app/d_images/no_image_thumb.png"; break;
		default			: $( id )[0].src = "https://www.nissen.co.jp/d_catalog/app/d_images/no_image_catalog.png"; break;
	}
}

// スクロールバーの横幅を取得
function getBarWidth(){
	var body = d.body,
		outer = d.createElement( "div" ),
		style = outer.style;

	style.width = "100px";
	style.height = "100px";
	style.overflow = "scroll";
	style.border = "none";
	style.visibility = "hidden";

	var inner = outer.cloneNode( false );

	outer.appendChild( inner );
	d.body.appendChild( outer );
	outer.scrollTop = 200;

	var barWidth = outer.scrollTop;

	body.removeChild( outer );

	return barWidth;
}


// カタログサイズ計算
var timer;
function catalogResize() {

	WINDOW_W = $( window ).width();
	WINDOW_H = $( window ).height();
	var page = $( "#page_wrapper" ),
		center = $( "#center_area" );

	if( Pageflag ) {

		clearTimeout( timer );

		var viewpoint,
			winH = $( window ).height(),
			bHeight = $( 'body' ).height(),
			wHeight = $( window ).innerHeight();

		viewpoint = ( ( wHeight - bHeight ) > 0 ) ? VIEWPOINT : VIEWPOINT - getBarWidth();

		if( WINDOW_W > VIEWPOINT ) {

			$( window ).scrollTop(0);

			$( "#container" ).css( "height", winH + "px" );
			page.addClass( "dragArea" ).removeClass( "cancel" );
			$( ".dragArea" ).draggable({ cancel : '.cancel' });

//			商品一覧タブをロード時に出した状態にする為コメントアウト　2014.6.2 Oguri
//			var mR = $( "#product_list_wrapper" ).css( "right" );
//			if( mR != "0px" && mR == "-274px" ) $( "#product_list_wrapper" ).css( "display", "none" );

			$( ".pd_upper" ).next().show();
			$( ".pd_upper" ).off( "click" );

			if( isIE7 || isIE8 ) $( "#popup-guide_wrapper" ).css( "height", "452px" );

			var ww = WINDOW_W - 274;

			if(($("#product_list_wrapper").css('right') != "-274px") && ((WINDOW_W / 2) - 274  < 440)){

				$("#footer").stop().animate({width:ww + "px"},0);
				$( "#next" ).css( "right", "274px" );

			}else if($("#footer").css("width") !="100%"){

				$("#footer").stop().animate({width:"100%"},0);
				$( "#next" ).css( "right", "0" );

			}

			if(!$("#list_btn").hasClass("side_close")){
				$( "#next" ).css( "right", "274px" );
			}

			setGuide();
			

		} else {
			//ズーム解除
			ZOOMIN=0;
			$( "#container" ).css( "height", "100%" );
			$( "#center_area" ).css( "height", "100%" );
			$( "#page_wrapper" ).css( "height", "100%" );
			$( "#leftP" ).css( "height", "100%" );
			$( "#rightP" ).css( "height", "100%" );
			$( "#next" ).css( "right", "0px" );
			center.css({ "width":"82%", "zoom":"1" });
			page.addClass( "cancel" ).removeClass( "dragArea" ).css({ "top":"0", "right":"0", "bottom":"0", "left":"0" });
			//画面が小さくなった時サイドバーを隠す操作
			//$( "#list_btn" ).css( "right", "-20px" );
			//$( "#product_list_wrapper" ).css({ display: "block", right: "-274px" });
			//$( "#list_btn img" ).attr( "src", $( "#list_btn img" ).attr( "src" ).replace( ".close.", ".open." ));
			
			
			$( ".pd_upper" ).next().hide();
			$( "#popup-guide_contents img" ).attr( "src", "https://www.nissen.co.jp/d_catalog/app/d_images/sp_how_to.png" );
			
			if( isIE7 || isIE8 ) $( "#popup-guide_wrapper" ).css( "height", "352px" );
			
			$("#footer").stop().animate({width:"100%"},0);
			toggleBtnReset();
			

		}

		if( ZOOMIN == 0 ) imgResize(); //拡大されてなければリサイズ
		
		( WINDOW_W > VIEWPOINT )
			? $( "#main" ).css( "height", $( window ).innerHeight() - 80 + "px" )
			: $( "#main" ).css({"width":"100%", "height":"100%" });

		timer = setTimeout( function() {

			center.off( "dblclick" ).on( "dblclick", "#page_wrapper", function( e ) {
				var X = e.pageX, Y = e.pageY;
				zoomAction( X, Y );
			});

			if( WINDOW_W > viewpoint ) {

				page.addClass( "dragArea" ).removeClass( "cancel" );
				$( ".dragArea" ).draggable({ cancel : '.cancel' });
				pc_btnAnimate();

			} else {
// 2015.12 左開き対応
				sp_btnAnimate();
				// SlideToggle event
				$( ".toggle_btn" ).off( "click" ).on( "click", function() {
					$(this).parent().parent().next().slideToggle( 200, function(){ setToggleBtn( this ); });
				});
			}

			$( ".row_wrapper" ).css( "marginLeft", "0" );
			$( ".index_left" ).css( "opacity", "0" );
			$( ".index_right" ).css( "opacity", "1" );

		}, 300);
		
		
		
		//描画がおかしくなる場合があるので、再描画させる
		$('#footer').css('display', 'none').height();
		$('#footer').css('display', 'block');

	}

}


//ページイメージサイズ計算
function initImgSize(){
	var imgSize = {};
	
	var $side = $("#product_list_wrapper");
	var sideSize = $side.width() +10;
	//サイドが表示されていなくてもサイドを想定する。想定しない場合は以下のコメントを外す
	//if($side.css('display') == "none") sideSize = 0;

	var maxW = $( window ).innerWidth() - sideSize;
	var maxH = $( window ).innerHeight() - 80;
	var imgW = CATALOG_RATIO[1];//横
	var imgH = CATALOG_RATIO[0];//縦
	//画面との比率を取得する
	var ratW = maxW / (imgW * 2);
	var ratH = maxH / imgH;
	//比率が小さい方に合わせる
	var rat = ratH;
	if(ratW < ratH) rat = ratW;
	//カタログサイズ取得
	var catlogW = Math.floor(imgW * rat);
	var catlogH = Math.floor(imgH * rat);
	//左側の位置決め
	var leftP = maxW - catlogW * 2;
	
	//設定
	imgSize.x = leftP;
	imgSize.y = 0;
	imgSize.w = catlogW;
	imgSize.h = catlogH;
	
	return imgSize;

}
// ページイメージサイズ計算
function imgResize() {
	WINDOW_W = $( window ).width();
	var one_pageW,
		viewpoint,
		spreadW = $( "#center_area" ).width(),
		bHeight = $( 'body' ).height(),
		wHeight = $( window ).innerHeight(),
		nHeight = $('#main').height();
	viewpoint = ( ( wHeight - bHeight ) > 0 ) ? VIEWPOINT : VIEWPOINT - getBarWidth();

	if( WINDOW_W > viewpoint ) {
		//ページのように表示

// 2015.12 左開き改修
//		var img_path =  byID( "leftP" ).getElementsByTagName( "img" )[0].src.slice( 0, -6 );
//		if( img_path.search( "loading" ) == -1 && img_path.search( "transpare" ) == -1 ) byID( "leftP" ).getElementsByTagName( "img" )[0].src = img_path + "_1.jpg";
		var img_path =  byID( "rightP" ).getElementsByTagName( "img" )[0].src.slice( 0, -6 );
		if( img_path.search( "loading" ) == -1 && img_path.search( "transpare" ) == -1 ) byID( "rightP" ).getElementsByTagName( "img" )[0].src = img_path + "_1.jpg";
		
		imgResize_set();
		

	}else{
		//一枚ずつ表示
		$("#page_wrapper").css("width","100%");
		$( "#leftP" ).css( "width", spreadW );
// 2015.12 左開き改修 
// 右ページの枠幅も合わせる
		$( "#rightP" ).css( "width", spreadW );
		$( "#center_area" ).css( "marginTop", "0px" );

	}

}
function imgResize_set(){
	var imgSize = initImgSize();
	if(imgSize.w > 0){
		$( "#leftP" ).css( "width", imgSize.w );
		$( "#rightP" ).css( "width", imgSize.w );
		$("#page_wrapper").css({"left":imgSize.x,"top":0,"width":imgSize.w * 2,"height":imgSize.h});
		$( "#center_area" ).css( "marginTop", "0px" );
	}else{
		setTimeout( imgResize_set, 100 );
	}
}

//初期一に移動
function firstPosition(){
	if( WINDOW_W > VIEWPOINT){
		ZOOMIN = 0;
		
		var imgSize = initImgSize();
		
		$("#leftP").stop().animate({"width": imgSize.w }, 400);
		$("#rightP").stop().animate({"width": imgSize.w }, 400);
		$("#page_wrapper").stop().animate({"left":imgSize.x ,"top":0,"width":imgSize.w * 2,"height":imgSize.h}, 400);
		$("#center_area").stop().animate({"marginTop":"0px"}, 400);
	
	}else{
		$( "#page_wrapper" ).css( { width: "100%", height: "100%" } );
		$( "#center_area, #leftP, #rightP" ).css( "height", "100%" );
	}
}



// ページ情報をセット
var img1, img2;
function setPages( page, Rightflag ) {
	var Lload = 0, Rload = 0;

	if( currentPage <= totalPages && currentPage >= 0 ) {

		if( !isIE8 ) $( "#leftP img, #rightP img" ).attr( "src", "https://www.nissen.co.jp/d_catalog/app/d_images/loading_page.gif" );

		if (typeof catalogPages[ page ] === 'undefined') {
			if (retryCount < 6) {
				setTimeout(function(){
					retryCount++;
					setPages( page, Rightflag );
				}, 1000);
			}

			return;
		}

		// ページタイトル
		byID( "page_name" ).getElementsByTagName( "p" )[0].innerHTML = catalogPages[ page ].page_theme;

		// ページ画像
		var img_path = "." + catalogPages[ page ].main_img.slice( 0, -4 );

		img1 = $( new Image() );
		img2 = $( new Image() );

		// スマホサイズで前ページに戻った場合、右片ページから表示されるようにする
		( WINDOW_W <= VIEWPOINT && Rightflag ) ? img1.attr( 'src', img_path + "_2.jpg" ) : img1.attr( 'src', img_path + "_1.jpg" );

		img2.attr( 'src', img_path + "_2.jpg" );

		if( !isIE8 ) {
			img1.bind( 'load', function(){
				if( Lload == 0 ) {
// 2015.12 左開き改修
// 左ページ表示画像変更
//					$( '#leftP' ).empty().append( img1 );
					$( '#leftP' ).empty().append( img2 );
					Lload++;
				}
			});
			img2.bind( 'load', function(){
				if( Rload == 0 ) {
// 2015.12 左開き改修
// 右ページ表示画像変更
//					$( '#rightP' ).empty().append( img2 );
					$( '#rightP' ).empty().append( img1 );
					Rload++;
				}
			});
		} else {
// 2015.12 左開き改修
// 左右ページ表示画像変更
//			$( '#leftP' ).empty().append( img1 );
//			$( '#rightP' ).empty().append( img2 );
			$( '#leftP' ).empty().append( img2 );
			$( '#rightP' ).empty().append( img1 );
		}

		catalogResize();

		// ページNo.
		byID("page_number").innerHTML = catalogPages[ page ].page_no;

		// ページアイテム
		if( Itemflag ) {
	
			byID( "product_contents" ).innerHTML = "";
			
			currentItems = [];

			var cnt = 0;
			var items = catalogPages[ page ].item_no;

			for( var j = 0, len = items.length - 1; j <= len; j++ ) {
				for( var i in catalogAllItems ) {
					if( items[j] == catalogAllItems[i].no ) {
						currentItems[ cnt ] = catalogAllItems[i];
						cnt++;
					}
				}
			}

			if( currentItems.length > 0 ) {
				setPageItems( currentItems );
			} else {
				var html = "<p id='no_item'>このページには商品はありません。</p>";
				byID("product_contents").innerHTML += html;
			}
	
		}
		
		// 表示ページをcookieに最終ページとして登録
		if ( navigator.cookieEnabled ) {
			var expire = new Date();
			expire.setTime( expire.getTime() + 1000 * 3600 * 24 * 180 );	
			d.cookie = "M" + currentCatalog + "=" + encodeURIComponent( catalogPages[ currentPage ].page_no ) + "; expires=" + expire.toUTCString();
		}

		// 次ページプリロード
		if( currentPage ) {
			var nextPage = Number( currentPage ) + 1;
			if( nextPage in catalogPages ) {
				nextPage = "." + catalogPages[ nextPage ].main_img.slice( 0, -4 );			
				$( "<img>" ).attr( "src", nextPage + "_1.jpg" );
				$( "<img>" ).attr( "src", nextPage + "_2.jpg" );
			}
		}
	}
}

var cnt = 0;
function setPageItems( items ) {

	var htmls = [];

	for (var i = 0, len = count(items); i < len; i++) {
		getCatalogInfoAndCreateHtml(currentCatalog, items[i], htmls, i);
	}

	// 各アイテムについてcreateItemHtmlでレスポンスが取得されるまで待機
	var intvId = setInterval(function() {
		for (var i = 0; i < count(items); i++) {
			if (typeof htmls[i] === 'undefined') {
				return;
			}
		}
		clearInterval(intvId);

		byID("product_contents").innerHTML += htmls.join('');
	}, 50);
}

// 次ページへ
var animateTimer;
function setNextPage() {

	clearTimeout( animateTimer );
	var flag = false;

// 2015.12 左開き改修
// 右を基準とする
//	var img_path = byID( "leftP" ).getElementsByTagName( "img" )[0].src.slice( 0, -4 ),
	var img_path = byID( "rightP" ).getElementsByTagName( "img" )[0].src.slice( 0, -4 ),
		src = img_path.slice( -2 );

// 2015.12 左開き改修
//	if( src.search( "_1" ) == -1 ) flag = true; //スマホサイズで右ページが表示されている場合はtrue
	if( src.search( "_1" ) == -1 ) flag = true; //スマホサイズで左ページが表示されている場合はtrue

	if( WINDOW_W > VIEWPOINT || flag ) {

		if( currentPage < totalPages ) {
			currentPage++;
			setPages( currentPage );
		}

		checkFavoritePage();

	} else {
		img_path = img_path.slice( 0, -2 );
// 2015.12 左開き改修
//		$( "#leftP img" ).attr( "src", img_path + "_2.jpg" );
		$( "#rightP img" ).attr( "src", img_path + "_2.jpg" );
	}

	if( WINDOW_W > VIEWPOINT ) {
		pc_btnNonAnimate();
	}else{
// 2015.12 左開き改修
		sp_btnAnimate();

		$( ".pd_upper" ).next().hide();
		$( ".toggle_btn" ).off( "click" ).on( "click", function() {
			$(this).parent().parent().next().slideToggle( 200, function(){ setToggleBtn( this ); });
		});
		toggleBtnReset();
		
	}

	animateTimer = setTimeout(function(){ sliderSlide(); }, 500 );

	$( "#page_wrapper" ).css( { width: "100%", height: "100%" } );
	$( "#center_area, #leftP, #rightP" ).css( "height", "100%" );
	ZOOMIN = 0;
}


// 前ページへ
function setPreviousPage() {

	clearTimeout( animateTimer );
	var flag = false;

// 2015.12 左開き改修 
// 右を基準とする
//	var img_path = byID( "leftP" ).getElementsByTagName( "img" )[0].src.slice( 0, -4 ),
	var img_path = byID( "rightP" ).getElementsByTagName( "img" )[0].src.slice( 0, -4 ),
		src = img_path.slice( -2 );

// 2015.12 左開き改修
//	if( src.search( "_1" ) > -1 ) flag = true; // スマホサイズで左ページが表示されている場合はtrue
	if( src.search( "_1" ) > -1 ) flag = true; // スマホサイズで右ページが表示されている場合はtrue

	if( WINDOW_W > VIEWPOINT || flag ){

		if( currentPage > 0 ) {
			currentPage--;
			setPages( currentPage, flag );
		}

		checkFavoritePage();

	} else {
		img_path = img_path.slice( 0, -2 );
// 2015.12 左開き改修
//		$( "#leftP img" ).attr( "src", img_path + "_1.jpg" );
		$( "#rightP img" ).attr( "src", img_path + "_1.jpg" );
	}

	if( WINDOW_W > VIEWPOINT ) {
		pc_btnNonAnimate();
	}else{
// 2015.12 左開き改修
		sp_btnAnimate();

		$( ".pd_upper" ).next().hide();
		$( ".toggle_btn" ).off( "click" ).on( "click", function() {
			$(this).parent().parent().next().slideToggle( 200, function(){ setToggleBtn( this ); });
		});
		toggleBtnReset();
	}

	animateTimer = setTimeout(function(){ sliderSlide(); }, 500);

	$( "#page_wrapper" ).css( { width: "100%", height: "100%" } );
	$( "#center_area, #leftP, #rightP" ).css( "height", "100%" );
	ZOOMIN = 0;
}


// ページ切替ボタン
function pc_btnAnimate() {
	var right = parseInt( byID( "next" ).style.right );
	
	if( currentPage == totalPages ) {
// 2015.12 左開き改修
//		( right == 274 ) ? $( "#next" ).stop().animate( { right: "280px" }, 200 ) : $( "#next" ).stop().animate( { right: "-60px" }, 200 );
//		$( "#previous" ).stop().animate( { left: "0px" }, 200 );
		( right == 274 ) ? $( "#next" ).stop().animate( { right: "274px" }, 200 ) : $( "#next" ).stop().animate( { right: "0px" }, 200 );
		$( "#previous" ).stop().animate( { left: "-60px" }, 200 );

	}else if( currentPage == 0 ) {
// 2015.12 左開き改修
//		( right == 274 ) ? $( "#next" ).stop().animate( { right: "274px" }, 200 ) : $( "#next" ).stop().animate( { right: "0px" }, 200 );
//		$( "#previous" ).stop().animate( { left: "-60px" }, 200 );
		$( "#next" ).stop().animate( { right: "-60px" }, 200 );
		$( "#previous" ).stop().animate( { left: "0px" }, 200 );

	}else if( currentPage > 0 && currentPage < totalPages ) {
		( right == 274 ) ? $( "#next" ).stop().animate( { right: "274px" }, 200 ) : $( "#next" ).stop().animate( { right: "0px" }, 200 );
		$( "#previous" ).stop().animate( { left: "0px" }, 200 );
	}
}

function pc_btnNonAnimate() {
	var right = parseInt( byID( "next" ).style.right ),
		right2 = parseFloat( byID( "product_list_wrapper" ).style.right );

	if( currentPage == totalPages ) {
// 2015.12 左開き改修
//		( right == 274 ) ? $( "#next" ).css( "right", "280px" ) : $( "#next" ).css({ right: "-60px", marginRight: "-20px" });
//		$( "#previous" ).css( "left", "0px" );
		( right == 274 ) ? $( "#next" ).css( "right", "274px" ) : $( "#next" ).css( "right", "0px" );
		$( "#previous" ).css({ left: "-60px", marginLeft: "-20px" });

	}else if( currentPage == 0 ) {
// 2015.12 左開き改修
//		( right == 274 ) ? $( "#next" ).css( "right", "274px" ) : $( "#next" ).css( "right", "0px" );
//		$( "#previous" ).css({ left: "-60px", marginLeft: "-20px" });
		$( "#next" ).css({ right: "-60px", marginRight: "-20px" });
		$( "#previous" ).css( "left", "0px" );

	}else if( currentPage > 0 && currentPage < totalPages ) {
		( right == 274 || right2 === 0 ) ? $( "#next" ).css( "right", "274px" ) : $( "#next" ).css( "right", "0px" );
		$( "#previous" ).css( "left", "0px" );
	}
}

function sp_btnAnimate() {
// 2015.12 左開き改修
//	if( currentPage == 0 ) {
//		$( "#next" ).stop().animate( { right: "0px" }, 200 );
//		$( "#previous" ).stop().animate( { left: "-60px" }, 200 );
//	}else{
//		$( "#next" ).stop().animate( { right: "0px" }, 200 );
//		$( "#previous" ).stop().animate( { left: "0px" }, 200 );
//	}
// ページによってページボタンの表示を制御
	var img_path = byID( "rightP" ).getElementsByTagName( "img" )[0].src.slice( 0, -4 ),
		src = img_path.slice( -2 );
	if( currentPage == 0 ) {
		(src.search("_1") > -1) ? $( "#next" ).stop().animate( { right: "-60px" }, 200 ) : $( "#next" ).stop().animate( { right: "0px" }, 200 );
		$( "#previous" ).stop().animate( { left: "0px" }, 200 );
	} else if(currentPage == totalPages) {
		$( "#next" ).stop().animate( { right: "0px" }, 200 );
		(src.search("_2") > -1) ? $( "#previous" ).stop().animate( { left: "-60px" }, 200 ) : $( "#previous" ).stop().animate( { left: "0px" }, 200 );
	} else if(currentPage > 0 && currentPage < totalPages) {
		$( "#next" ).stop().animate( { right: "0px" }, 200 );
		$( "#previous" ).stop().animate( { left: "0px" }, 200 );
	}

}


// 縮小イベント
function scaleDown() {			
	$( "#center_area" ).css({ "width":"82%", "zoom":"1" });
	$( "#page_wrapper" ).css({ "top":"0px", "left":"0px" });
	imgResize();
}


// お気に入りページチェック
function checkFavoritePage() {
	var favorite = byID( "btn-favorite" );
	var src = favorite.childNodes[0].src.replace( ".selected", ".up" );
	favorite.childNodes[0].src = src;
	
	var src2 = favorite.childNodes[1].src.replace( ".selected", ".up" );
	favorite.childNodes[1].src = src2;

	if (typeof catalogPages[ currentPage ] === 'undefined') {
		if (retryCount < 6) {
			setTimeout(function(){
				retryCount++;
				checkFavoritePage();
			}, 1000);
		}

		return;
	}

	if( $.inArray( catalogPages[ currentPage ].page_no, favoritePage ) != -1 ) {
		src = favorite.childNodes[0].src.replace( ".over", ".selected" ).replace( ".up", ".selected" );
		favorite.childNodes[0].src = src;
		
		var src2 = favorite.childNodes[1].src.replace( ".over", ".selected" ).replace( ".up", ".selected" );
		favorite.childNodes[1].src = src2;
	} else {
		src = favorite.childNodes[0].src.replace( ".selected", ".over" );
		favorite.childNodes[0].src = src;
		
		var src2 = favorite.childNodes[1].src.replace( ".selected", ".over" );
		favorite.childNodes[1].src = src2;
	}
}


// ページリンク
function turnPages( page_no ) {
	for( var i in catalogPages ) {
		if( page_no == catalogPages[i].page_no ) currentPage = Number( i ); 
	}
	setPages( currentPage );
	checkFavoritePage();
	sliderSlide();
	setTimeout(function(){ ( WINDOW_W > VIEWPOINT ) ? pc_btnAnimate() : sp_btnAnimate(); }, 500);

}


// ページスライダーの移動
function sliderSlide(){
    // 2016.02 左開き改修 スライダーの方向を右から左に変更
	var num = 100 - ( Number( currentPage ) / totalPages * 100);
	var num2 = num - 6.2;

	$( ".ui-slider-handle" ).stop().animate( { left : num + "%" }, 200 );
	$( "#pc-page_slider_thumb" ).stop().animate( { left : num2 + "%" }, 200 );

	var thumb_path = "." + catalogPages[ currentPage ].small_img,
		page_theme = catalogPages[ currentPage ].page_theme,
		page_no = catalogPages[ currentPage ].page_no;
	
	byID( "pc-page_slider_thumb" ).getElementsByTagName( "div" )[0].innerHTML = page_no;
	byID( "pc-page_slider_thumb" ).getElementsByTagName( "p" )[0].innerHTML = page_theme;
	byID( "pc-page_slider_thumb" ).getElementsByTagName( "img" )[0].src = thumb_path;
	
}


// ページ拡大・縮小
function zoomPosition(pageX,pageY) {
	if( WINDOW_W > VIEWPOINT ){
		if(ZOOMIN == 0){
			//元のサイズ
			firstPosition();
			
		}else{
			//拡大
			var center = $( "#center_area" ),
				page = $( "#page_wrapper" );
			
			var imgSize = initImgSize();

			var beforeLeft = parseInt( byID( "page_wrapper" ).style.left ),
				beforeTop = parseInt( byID( "page_wrapper" ).style.top );
			var ww, yy, x, y, per;

			if( !beforeLeft ) beforeLeft = 0;
			if( !beforeTop ) beforeTop = 0;

			if(ZOOMIN == 1){
				ww = (imgSize.w + CATALOG_RATIO[1]);
			}else{
				//等倍
				ww = CATALOG_RATIO[1] * 2;
			}
			hh = (CATALOG_RATIO[0] / CATALOG_RATIO[1]) * (ww/2);
			
			per = ww / page.width();
			
			x = ( pageX - page.offset().left ) * per - ( pageX - page.offset().left) - beforeLeft;
			y = ( pageY - page.offset().top ) * per - ( pageY - page.offset().top ) - beforeTop;

			page.stop().animate( { width: ww, height: hh, left: -x, top: -y }, 300 );
			$( "#leftP, #rightP" ).stop().animate( { width: ww / 2, height: hh }, 301 );
		}
		
	}else{
		//spサイズ
		
		var center = $( "#center_area" ),
			page = $( "#page_wrapper" );
		
		var PAGE_W = page.width(),
			PAGE_H = page.height(),
			beforeLeft = parseInt( byID( "page_wrapper" ).style.left ),
			beforeTop = parseInt( byID( "page_wrapper" ).style.top ),
			x, y, per, ww, hh;

		if( !beforeLeft ) beforeLeft = 0;
		if( !beforeTop ) beforeTop = 0;

		if(ZOOMIN == 0){
			//元のサイズ
			page.stop().animate({ "top":"0", "right":"0", "bottom":"0", "left":"0" ,"width":"100%","height":"100%"});
			$( "#leftP, #rightP" ).stop().animate( { width: "100%", height: "100%" }, 301 );
			
		}else{
			 if(ZOOMIN == 1){
				ww = ( CATALOG_RATIO[1] + center.width() ) / 2;
 			}else{
 				//等倍
				ww = CATALOG_RATIO[1];
 			}
			hh = (CATALOG_RATIO[0] / CATALOG_RATIO[1]) * (ww);
			per = ww / page.width();
			
			x = ( pageX - page.offset().left ) * per - ( pageX - page.offset().left) - beforeLeft;
			y = ( pageY - page.offset().top ) * per - ( pageY - page.offset().top ) - beforeTop;

			center.css( "height", $( "#center_area" ).height() );
			page.addClass( "dragArea" ).removeClass( "cancel" ).stop().animate( { width: ww, height: hh, left: -x, top: -y }, 300 );
			$( ".dragArea" ).draggable({ cancel : '.cancel' });	
			
			$( "#leftP, #rightP" ).stop().animate( { width: ww, height: hh }, 301 );
			
			
		}
	}
}

// ページ拡大
function zoomAction(pageX,pageY) {
	//初期表示→拡大→等倍に拡大→初期表示
	
	ZOOMIN ++;
	if(ZOOMIN > 2) ZOOMIN = 0;
		
	zoomPosition(pageX,pageY);
	
}


// test start

// ページ拡大・縮小　Touch device
function zoomActionSP( pageX, pageY ) {

	var center = $( "#popup-page_wrapper" ),
		page = $( "#popup-page_area" );

	var DIV_W = center.width(),
		DIV_H = center.height(),
		PAGE_W = page.width(),
		PAGE_H = page.height(),
		beforeLeft = parseInt( byID( "popup-page_area" ).style.left ),
		beforeTop = parseInt( byID( "popup-page_area" ).style.top ),
		x, y, per;

		if( !beforeLeft ) beforeLeft = 0;
		if( !beforeTop ) beforeTop = 0;

	if ( ZOOMIN >= 2 ) {	
			page.stop().animate( { width: DIV_W, height: DIV_H, left: 0, top: 0 }, 400 );
			$( "#popup-page_area" ).stop().animate( { width: DIV_W, height: DIV_H, left: 0, top: 0 }, 400 );
		
		setTimeout(function(){
			page.css( { width: "100%", height: "100%" } );
			$( "#popup-page_area" ).css( "height", "100%" );
		}, 500);

		ZOOMIN = 0;

	} else {

		if( ZOOMIN == 0 ) {
			var ww = ( CATALOG_RATIO[1] * 2 - PAGE_W ) / 2 + PAGE_W,
				hh = ( CATALOG_RATIO[0] - PAGE_H ) / 2 + PAGE_H;
		}else{
			var ww = CATALOG_RATIO[1] * 2,
				hh = CATALOG_RATIO[0];
		}

		per = ( WINDOW_W > VIEWPOINT ) ? ww / PAGE_W : ww / ( PAGE_W * 2 );
		
		x = ( pageX - page.offset().left ) * per - ( pageX - page.offset().left) - beforeLeft;
		y = ( pageY - page.offset().top ) * per - ( pageY - page.offset().top ) - beforeTop;

		center.css( "height", $( "#popup-page_area" ).height() );
		page.stop().animate( { width: ww / 2, height: hh, left: -x, top: -y }, 300 );
		
		$( "#popup-page_area" ).stop().animate( { width: ww / 2, height: hh }, 301 );

		ZOOMIN++;

	}
}

// test end

// ページ一覧ポップアップ内nextボタン
function setIndexNext( id ) {

	var category = $( id ).parents()[1].childNodes[1].childNodes[0].innerHTML;
	
	var prevBtn = $( id ).parents()[1].childNodes[0].childNodes[0];
	prevBtn.style.opacity = 1;

	for( var i in currentCatalogIndex ) {
		if( i == category ) {

			var len = currentCatalogIndex[i].length,
				that = $( id ).parents()[1].childNodes[0].childNodes[1].childNodes[0],
				marginL = parseInt( that.style.marginLeft );

			if( WINDOW_W > VIEWPOINT ) {
				var num = 696,
					visible = 4;
			} else {
				var num = 230,
					visible = 2;
			}

			var calc = marginL - num,
				calc2 = Math.floor( len / visible ) * num,
				calc3 = len % visible;

			if( calc3 == 0 ) calc2 -= num;

			if( marginL > -calc2 ) $( that ).stop().animate( { marginLeft: calc + "px" }, 400 );
			
			if( marginL <= -( calc2 - num ) ) $( id ).stop().animate({ opacity: "0" }, 200);

			setTimeout(function(){
				
				$( "#popup-index_thumbnail_wrapper" ).on( "click", ".theme_img", function(){

					$( "#page_wrapper" ).css( { width: "100%", height: "100%", top: "0", left: "0" } );
					$( "#center_area, #leftP, #rightP" ).css( "height", "100%" );
					ZOOMIN = 0;
				
					var num = $( this )[0].childNodes[1].innerHTML;
				
					turnPages( num );
					if( WINDOW_W <= VIEWPOINT ) $( ".pd_upper" ).next().hide();
				
				});
				
				$( "#popup-index_thumbnail_wrapper" ).on( "click", ".index_right", function(){
					$( "#popup-index_thumbnail_wrapper" ).off( "click" );
					setIndexNext( this );
				});
				$( "#popup-index_thumbnail_wrapper" ).on( "click", ".index_left", function(){
					$( "#popup-index_thumbnail_wrapper" ).off( "click" );
					setIndexPrev( this );
				});
			}, 410);

			break;
		}
	}
}

// ページ一覧ポップアップ内prevボタン
function setIndexPrev( id ) {
	
	var category = $( id ).parents()[1].childNodes[1].childNodes[0].innerHTML;
	
	var nexrtBtn = $( id ).parents()[1].childNodes[0].childNodes[2];
	nexrtBtn.style.opacity = 1;

	for( var i in currentCatalogIndex ) {
		if( i == category ) {
		
			var len = currentCatalogIndex[i].length,
				that = $( id ).parents()[1].childNodes[0].childNodes[1].childNodes[0],
				marginL = parseInt( that.style.marginLeft );
			
			if( marginL < 0  ) {
				var calc = ( WINDOW_W > VIEWPOINT ) ? marginL + 696 : marginL + 230;
				$( that ).stop().animate({ marginLeft: calc + "px" }, 400);
			}
			
			if( calc >= 0  ) $( id ).stop().animate({ opacity: "0" }, 200);

			setTimeout(function(){
			
				$( "#popup-index_thumbnail_wrapper" ).on( "click", ".theme_img", function(){

					$( "#page_wrapper" ).css( { width: "100%", height: "100%", top: "0", left: "0" } );
					$( "#center_area, #leftP, #rightP" ).css( "height", "100%" );
					ZOOMIN = 0;
				
					var num = $( this )[0].childNodes[1].innerHTML;
				
					turnPages( num );
					if( WINDOW_W <= VIEWPOINT ) $( ".pd_upper" ).next().hide();
				
				});		

				$( "#popup-index_thumbnail_wrapper" ).on( "click", ".index_left", function(){
					$( "#popup-index_thumbnail_wrapper" ).off( "click" );
					setIndexPrev( this );
				});

				$( "#popup-index_thumbnail_wrapper" ).on( "click", " .index_right", function(){
					$( "#popup-index_thumbnail_wrapper" ).off( "click" );
					setIndexNext( this );
				});

			}, 410);

			break;

		}
	}
}

// Toggleボタン
function setToggleBtn( id ) {
	var img = $( id ).prev()[0].childNodes[1].childNodes[4],
		imgRe = img.src.slice( 0, -9 );
	( img.src.search( "open1" ) > -1 ) ? img.src = imgRe + "close.png" : img.src = imgRe + "open1.png";
}

// Toggleボタンリセット
function toggleBtnReset() {
	var toggleBtnAmount = $( "#product_contents .toggle_btn" ).size();
	if( toggleBtnAmount > 0 ) {
		for( var i = 0; i < toggleBtnAmount; i++ ){
			$( "#product_contents .toggle_btn" )[i].src = $( "#product_contents .toggle_btn" )[i].src.replace( ".close.", ".open1." );
		}
	}
}

// クッキーの値をオブジェクトで取得
function getCookies() {
	var cookies = decodeURIComponent( d.cookie ).split( "; " );
	var str = [];
	var cookieObj = new Object;
	for( var i = 0; i < cookies.length; i++ ) {
		str = cookies[i].split( "=" );
		cookieObj[ str[0] ] =  ( str[1] != "null" ) ? str[1] : null;
	}
	return cookieObj;
}

// popup height
function setPopupHeight( id ) {
	var winH = $( window ).height(),
		container = byID( id ).childNodes[1],
		wrapper = ( id.search( "index" ) > -1 || id.search( "guide" ) > -1 )
					? byID( id ).childNodes[1].childNodes[7]
					: byID( id ).childNodes[1].childNodes[5].childNodes[0];
	container.style.height = winH - 80 + "px";
	wrapper.style.height = winH - 200 + "px";
}

// カタログの使い方ポップアップ
function setGuide() {
	if( WINDOW_W > VIEWPOINT ) {
		var guideLink = $( ".guide_link" ),
			selNum = $( "select[name='guide_list'] option:selected" ).val();
		switch( selNum ) {
			default  : guideLink.css( "display", "block" ); $( "#popup-guide_contents img" ).attr( "src", "https://www.nissen.co.jp/d_catalog/app/d_images/how_to.png" ); break;
			case "2" : guideLink.css( "display", "none" ); $( "#popup-guide_contents img" ).attr( "src", "https://www.nissen.co.jp/d_catalog/app/d_images/how_to_like.png" ); break;
			case "3" : guideLink.css( "display", "none" ); $( "#popup-guide_contents img" ).attr( "src", "https://www.nissen.co.jp/d_catalog/app/d_images/how_to_other.png" ); break;
			case "4" : guideLink.css( "display", "none" ); $( "#popup-guide_contents img" ).attr( "src", "https://www.nissen.co.jp/d_catalog/app/d_images/how_to_index.png" ); break;
		}
	} else {
		$( "#popup-guide_contents img" ).attr( "src", "https://www.nissen.co.jp/d_catalog/app/d_images/sp_how_to.png" );
	}
}

function getComma ( num ) {
	num = new String( num ).replace( /,/g, "" );
	while( num != ( num = num.replace( /^([0-9]+)([0-9]{3})/, "$1,$2" ) ) );
	return num;
}

// カート追加時にカタリストロギング
function doCatalystLoggingForCart( bookNoValue, syoNoValue, colorValue, sizeValue, amountValue) {
	var s=s_gi("nssnnissencojpprod");
	s.events="scAdd,event3";
	s.eVar1=bookNoValue;
	s.eVar2=getLocation("デジカタ",true);
	s.eVar3=getCategoryName("デジカタ",true);
	s.eVar4=getEventName("",true);
	s.eVar11=colorValue;
	s.eVar12=sizeValue;
	s.products=";" + bookNoValue + "_" + syoNoValue + ";;;event3=" + amountValue;

	s.linkTrackVars="events,products,eVar1,eVar2,eVar3,eVar4,eVar11,eVar12,prop23"
	//var openHref = window.opener.location.href;
	var openHref = "";
	if (window.opener != null && document.referrer != "" ) {
		openHref = window.opener.location.href;  //親ウィンドウのリファラURL
	}else{
		openHref = document.referrer;          //自ウィンドウのリファラURL
	}

	var openSiteName = "その他";
	try{
		if(openHref.indexOf("sho_item") > -1){
			openSiteName = "商品詳細";
		}else if(openHref.indexOf("digitalcatalog") > -1){
			openSiteName = "デジカタトップ";
		}
	}catch(e){
	}

	s.prop23 = openSiteName + "＞デジカタカート";

	s.tl(this,'o',"デジカタカート");
	s.events="";
	s.eVar1="";
	s.eVar2="";
	s.eVar3="";
	s.eVar4="";
	s.eVar11="";
	s.eVar12="";
	s.products="";
	s.prop23 = "";
	s.linkTrackVars="events,products,eVar1,eVar2,eVar3,eVar4,eVar10,eVar11,eVar12,prop28";
}
